import React, { useState } from 'react'
import Button from '../../../components/Button/Button'
import { showSnackBar } from '../../../components/Snackbar/Snackbar'
import { useMyContextLoading } from '../../../components/LoadingContextProvider/LoadingContextProvider'
import { downloadEnrolledReport } from '../../../features/enrolledReport/enrolledReport'

const EnrolledReport = () => {
  const { triggerLoading } = useMyContextLoading()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleExport = async () => {
    setIsSubmitting(true)
    triggerLoading(true)

    try {
      await downloadEnrolledReport()
      showSnackBar('success', 'Enrolled report downloaded successfully!')
    } catch (error) {
      showSnackBar('error', error?.response?.data?.message || 'Failed to download report')
    } finally {
      setIsSubmitting(false)
      triggerLoading(false)
    }
  }

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Enrolled Files Report</h2>
      <p className="text-text-secondary mb-6">
        Export a comprehensive report of all enrolled contacts including affiliate info,
        account status, payment plan status, monthly payment amount, and the first 10 payment details.
      </p>

      <Button
        onClick={handleExport}
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Downloading...' : 'Download Enrolled Report'}
      </Button>
    </div>
  )
}

export default EnrolledReport
